import { LeafTypes, NodeType } from 'shared/types/ingestion'

export type BodyFilterType = 'equal' | 'notEqual' | 'self'
type IncludingExcludeFilterType = 'including' | 'excluding'
export type TreeFilterType = NodeFilterType | LeafFilterType

export enum FilterType {
  leaf,
  node,
}

export type FilterValueTypes = string | number | boolean | RegExp | null

type FilterEntry = {
  filterType: IncludingExcludeFilterType
  caseInsensitive?: boolean
}

export type ContentFilterType = {
  ALL_OR?: boolean
} & Record<Exclude<string, 'ALL_OR'>, FilterEntry>

export type TypeSelections = {
  filterType: IncludingExcludeFilterType | 'duplicateSibling'
  types: (NodeType | LeafTypes)[]
}

interface BaseFilter {
  filterType: FilterType
  typeSelections?: TypeSelections
  body?: Record<string, ValueFilter>
  descendantOf?: {
    directDescendant?: boolean
    filter: NodeFilterType
  }
  withDescendant?: {
    directDescendant?: boolean
    mustIncludeAll: boolean
    filter: (NodeFilterType | LeafFilterType)[]
  }
  withContent?: ContentFilterType
}

export type ValueFilter = {
  type: BodyFilterType
  value: FilterValueTypes[]
}

export interface NodeFilterType extends BaseFilter {
  filterType: FilterType.node
  sibling?: NodeFilterType
}

export interface LeafFilterType extends BaseFilter {
  filterType: FilterType.leaf
  sibling?: LeafFilterType
}

export type Action = DeleteAction | BodyUpdateAction | TypeChangeAction
export type ActionType = 'delete' | 'bodyUpdate' | 'typeChange'

export interface DeleteAction {
  actionType: 'delete'
}

export interface BodyUpdateAction {
  actionType: 'bodyUpdate'
  data: Record<string, string | number | boolean>
}

export interface TypeChangeAction {
  actionType: 'typeChange'
  data: {
    newType: NodeType | LeafTypes
  }
}
